import Card3D from './Card3D.js';
import useIntro from './useIntro.js';

export default function PlaceholderPage({ title, icon: Icon, description }) {
  const isIntro = useIntro();
  const stagger = (i) =>
    isIntro
      ? { className: 'stagger-in', style: { '--i': i } }
      : { className: '', style: undefined };

  const dummyItems = [
    { label: 'Active Tasks', value: '—' },
    { label: 'Pending Items', value: '—' },
    { label: 'Last Updated', value: 'Just now' },
  ];

  return (
    <div className="space-y-6">
      <div className={stagger(0).className} style={stagger(0).style}>
        <Card3D className="content-glass rounded-xl p-8 text-center" intensity={6} lift={12}>
          <div
            className="w-16 h-16 rounded-2xl border flex items-center justify-center mx-auto mb-4"
            style={{
              background: 'linear-gradient(to bottom right, rgba(59,130,246,0.20), rgba(250,204,21,0.20))',
              borderColor: 'var(--nad-b2)',
            }}
          >
            <Icon size={32} style={{ color: 'var(--nad-accent-txt)' }} />
          </div>
          <h2 className="text-xl font-bold mb-2" style={{ color: 'var(--nad-t1)' }}>{title}</h2>
          <p className="text-sm max-w-md mx-auto" style={{ color: 'var(--nad-t3)' }}>{description}</p>
        </Card3D>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {dummyItems.map((item, i) => {
          const s = stagger(i + 1);
          return (
            <div key={item.label} className={s.className} style={s.style}>
              <Card3D className="content-glass rounded-xl p-5 text-center h-full">
                <p className="text-[10px] uppercase tracking-widest mb-2" style={{ color: 'var(--nad-t4)' }}>
                  {item.label}
                </p>
                <p className="text-lg font-bold" style={{ color: 'var(--nad-t2)' }}>{item.value}</p>
              </Card3D>
            </div>
          );
        })}
      </div>

      <div className={stagger(4).className} style={stagger(4).style}>
        <Card3D
          className="content-glass rounded-xl p-12 flex flex-col items-center justify-center"
          intensity={4}
          lift={8}
        >
          <div
            className="w-20 h-20 rounded-full border border-dashed flex items-center justify-center mb-4 mx-auto"
            style={{ background: 'var(--nad-s1)', borderColor: 'var(--nad-b2)' }}
          >
            <span className="text-3xl">🚧</span>
          </div>
          <h3 className="text-sm font-semibold mb-1 text-center" style={{ color: 'var(--nad-t3)' }}>
            Module Under Development
          </h3>
          <p className="text-xs text-center max-w-xs mx-auto" style={{ color: 'var(--nad-t4)' }}>
            This section is currently being built. Check back soon for updates and new features.
          </p>
        </Card3D>
      </div>
    </div>
  );
}
